<template>
  <div>
    <el-row type="flex" align="middle" justify="space-between">
      <el-col :span="12">
        <div class="page-title">作業詳情</div>
      </el-col>
      <el-col :span="4" style="text-align: right;">
        <el-button type="info" @click="onEditButton">編輯作業</el-button>
      </el-col>
    </el-row>
    <div class="page-box">
      <vue-dividing-line title="基本信息"></vue-dividing-line>
      <el-row :gutter="20" class="page-row-list">
        <el-col :span="8"> 課題編號：{{ detail.number }} </el-col>
        <el-col :span="8"> 語言: {{ detail.lang | language}} </el-col>
        <el-col :span="8"> 年級：{{ detail.gradeName }} </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8"> 開始日期：{{ detail.startDate | formatDate }} </el-col>
        <el-col :span="8"> 結束日期：{{ detail.endDate | formatDate }} </el-col>
      </el-row>
      <vue-dividing-line title="題目"></vue-dividing-line>
      <el-row class="page-row-list">
        <el-col :span="12"> 及格分數線：{{ detail.passScore }} </el-col>
      </el-row>
      <el-row class="page-row-list">
        <el-col :span="12"> 題目列表： </el-col>
        <el-col :span="12"> 及格分數線：{{ detail.passScore }} </el-col>
      </el-row>
      <el-table :data="detail.homeworkScopes" style="width: 100%;">
        <el-table-column prop="topicNumber" label="課題">
           <template slot-scope="scope">
             <el-button type="text" size="mini" @click="onShowTopic(scope.row.topicId)">{{scope.row.topicNumber}}</el-button>
           </template>
        </el-table-column>
        <el-table-column prop="practiseNumber" label="練習">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="onShowPractise(scope.row.practiseId)"
            >{{scope.row.practiseNumber}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="randomNumber" label="隨機抽取"> </el-table-column>
      </el-table>
      <vue-dividing-line title="學生"></vue-dividing-line>
      <el-row>
        <el-col :span="12"> 學生名單： </el-col>
      </el-row>
      <el-table :data="detail.students" style="width: 100%;">
        <el-table-column prop="userNo" label="學生帳號"> </el-table-column>
        <el-table-column prop="name" label="學生姓名"> </el-table-column>
        <el-table-column prop="gradeName" label="年級"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getHomeworksDetail } from "@/api/homeworks";
export default {
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      detail: {},
    };
  },
  created() {
    this.getHomeworksDetail();
  },
  methods: {
    onShowTopic(id){
      let path = `/topic/${id}`
      // this.$router.push({ path: `/topic/${id}` });
      this.resolveRouter(path)
    },
    onShowPractise(id){
      let path = `/practice/${id}`
      // this.$router.push({ path: `/practice/${id}` });
      this.resolveRouter(path)
    },
    onEditButton() {
      let path = `/job/${this.id}/edit`
      this.resolveRouter(path)
    },
    getHomeworksDetail() {
      getHomeworksDetail(this.id).then((v) => {
        this.detail = v.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  padding: 10px;
  background-color: #fff;
  margin-top: 20px;
}
</style>